'use client';

import React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Marketing360Form } from '@/components/ui/Marketing360Form';
import { GetInTouchSection } from '@/components/ui/sections/GetInTouch';
import SectionBase from '@/components/ui/sections/section-base';
import { FORM_SECTION_ID } from './consts';
import DecisionMakingSection from './ui/decision-making-section';
import { RequestConsultationHero } from './ui/RequestConsultationHero';
import WorkingTogetherSection from './ui/working-together-section';

function RequestConsultationPage() {
  return (
    <>
      <RequestConsultationHero />

      <WorkingTogetherSection />
      <DecisionMakingSection />

      <SectionBase id={FORM_SECTION_ID} background="bg-background">
        <Card>
          <CardHeader>
            <CardTitle>Request your consultation Today</CardTitle>

            <CardDescription>
              Complete the following form and Craig will contact you within
              24 business hours to schedule your consultation.
            </CardDescription>
          </CardHeader>

          <CardContent>
            <Marketing360Form />
          </CardContent>
        </Card>
      </SectionBase>

      <GetInTouchSection />
    </>
  );
}

export default RequestConsultationPage;
